/* tslint:disable */

/**
 * The user types:
 *   * ADMIN_LNG : a LNG administrator user
 *   * DRIVER_LNG: a LNG Driver user
 *   * ENGINEER_LNG: a LNG Engineer user
 *   * FINANCE_LNG : a LNG Finance user
 *   * LOGISTIC_LNG : a LNG Logistic user
 *   * OPERATOR_LNG : a LNG Operator user
 */
type UserLNGType =
  'ADMIN_LNG' |
  'DRIVER_LNG' |
  'ENGINEER_LNG' |
  'FINANCE_LNG' |
  'LOGISTIC_LNG' |
  'OPERATOR_LNG';
namespace UserLNGType {
  export const ADMIN_LNG: UserLNGType = 'ADMIN_LNG';
  export const DRIVER_LNG: UserLNGType = 'DRIVER_LNG';
  export const ENGINEER_LNG: UserLNGType = 'ENGINEER_LNG';
  export const FINANCE_LNG: UserLNGType = 'FINANCE_LNG';
  export const LOGISTIC_LNG: UserLNGType = 'LOGISTIC_LNG';
  export const OPERATOR_LNG: UserLNGType = 'OPERATOR_LNG';
  export function values(): UserLNGType[] {
    return [
      ADMIN_LNG,
      DRIVER_LNG,
      ENGINEER_LNG,
      FINANCE_LNG,
      LOGISTIC_LNG,
      OPERATOR_LNG
    ];
  }
}

export { UserLNGType }